import { render } from "./AnimationCard.vue?vue&type=template&id=3c0b5a67&scoped=true"
import script from "./AnimationCard.vue?vue&type=script&lang=js"
export * from "./AnimationCard.vue?vue&type=script&lang=js"

import "./AnimationCard.vue?vue&type=style&index=0&id=3c0b5a67&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0b5a67"]])

export default __exports__